"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../hooks");

var FieldWrapper = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      className = _useClassNames.className,
      classNames = _useClassNames.classNames,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["className", "classNames"]);

  var id = restProps.id,
      variant = restProps.variant,
      label = restProps.label,
      iconAfter = restProps.iconAfter,
      helperText = restProps.helperText,
      fieldType = restProps.fieldType,
      disabled = restProps.disabled,
      error = restProps.error,
      Field = restProps.Field,
      children = restProps.children,
      isValidating = restProps.isValidating,
      noFieldBorder = restProps.noFieldBorder,
      fieldProps = (0, _objectWithoutPropertiesLoose2.default)(restProps, ["id", "variant", "label", "iconAfter", "helperText", "fieldType", "disabled", "error", "Field", "children", "isValidating", "noFieldBorder"]);
  var showBorder = !noFieldBorder && variant === 'fill';
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: ((fieldType ? fieldType + classNames() : '') + " " + classNames([{
      variant: variant
    }, {
      disabled: disabled
    }, {
      error: Boolean(error)
    }]) + " " + className).trim()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('inputWrapper')
  }, Field && /*#__PURE__*/_react.default.createElement(Field, (0, _extends2.default)({
    ref: ref,
    id: id,
    disabled: disabled
  }, fieldProps)), children, label && /*#__PURE__*/_react.default.createElement("span", {
    className: classNames('label')
  }, label), showBorder && /*#__PURE__*/_react.default.createElement("span", {
    className: classNames('border')
  }), iconAfter && /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('icon')
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: iconAfter
  })), isValidating && /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('icon')
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-spinner fa-spin"
  }))), helperText && /*#__PURE__*/_react.default.createElement("span", {
    className: classNames('helperText')
  }, helperText), error &&
  /*#__PURE__*/
  // TODO: Add errorText styles
  _react.default.createElement("span", {
    className: classNames('helperText errorText')
  }, error));
});

FieldWrapper.propTypes = {
  alias: _propTypes.default.string,
  elementChar: _propTypes.default.string,
  modifierChar: _propTypes.default.string,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  variant: _propTypes.default.string,
  label: _propTypes.default.string,
  iconAfter: _propTypes.default.string,
  helperText: _propTypes.default.node,
  children: _propTypes.default.node,
  fieldType: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.string,
  Field: _propTypes.default.elementType,
  isValidating: _propTypes.default.bool,
  noBorder: _propTypes.default.bool
};
FieldWrapper.defaultProps = {
  alias: 'Field',
  elementChar: '_',
  modifierChar: '___',
  className: '',
  variant: 'fill',
  label: '',
  iconAfter: '',
  helperText: '',
  fieldType: '',
  disabled: false
};
FieldWrapper.displayName = 'FieldWrapper';
var _default = FieldWrapper;
exports.default = _default;